import script from "./LedgerTransactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./LedgerTransactions.vue?vue&type=script&setup=true&lang=ts"

import "./LedgerTransactions.vue?vue&type=style&index=0&id=ac9244c8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac9244c8"]])

export default __exports__